import React from 'react';

import FacebookIcon from '../../assets/images/icon/facebook.svg';
import LinkedInIcon from '../../assets/images/icon/linkedin.svg';
import InstagramIcon from '../../assets/images/icon/instagram.svg';

import SocImg from '../../assets/images/soc-img.jpg';

export const Social = () => {
  return (
    <div className="social">
      <div className="container">
        <div className="social__wr">
          <div className="social__image">
            <img src={SocImg} alt="img" />
          </div>
          <div className="social__content">
            <h4>
              Follow us on <br /> social media
            </h4>
            <p>
              {/* eslint-disable-next-line react/no-unescaped-entities */}
              Let's keep in touch
            </p>
            <div className="social__btns">
              <a
                href="https://www.facebook.com/109759547512440"
                className="social__btn"
                target="_blank"
                rel="noreferrer"
              >
                <div className="social__btn_wrapper">
                  <img src={FacebookIcon} alt="FacebookIcon" />
                  <span>Facebook</span>
                </div>
              </a>
              <a
                href="https://www.linkedin.com/company/v-lineco-inc"
                className="social__btn"
                target="_blank"
                rel="noreferrer"
              >
                <div className="social__btn_wrapper">
                  <img src={LinkedInIcon} alt="LinkedInIcon" />
                  <span>LinkedIn</span>
                </div>
              </a>
              <a
                href="https://www.instagram.com/vlineinc"
                className="social__btn"
                target="_blank"
                rel="noreferrer"
              >
                <div className="social__btn_wrapper">
                  <img src={InstagramIcon} alt="InstagramIcon" />
                  <span>Instagram</span>
                </div>
              </a>
            </div>
          </div>
          
        </div>
      </div>
    </div>
  );
};
